import { Component } from '@angular/core';

@Component({
  selector: 'lib-switch',
  standalone: true,
  imports: [],
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.css'
})
export class SwitchComponent {

}
